import React, { CSSProperties } from 'react';

type Props = {
  style?: CSSProperties;
  fill?: string;
  width?: string | number;
  className?: string;
  viewBox?: string;
};

const SVG: React.FC<Props> = ({
  style = {},
  fill = '#000',
  width = '100%',
  className = '',
  viewBox = '0 0 3.45 3.45',
}) => (
  <svg
    width={width}
    style={style}
    height={width}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <g id="Camada_2" data-name="Camada 2">
      <g id="Layer_2" data-name="Layer 2">
        <path
          fill={fill}
          d="M2.48,1.94a1,1,0,0,1-.69-.28,1,1,0,0,1,0-1.38,1,1,0,0,1,1.38,0,1,1,0,0,1,0,1.38A1,1,0,0,1,2.48,1.94Zm0-1.82a.82.82,0,0,0-.6.25.85.85,0,1,0,1.2,0A.83.83,0,0,0,2.48.12Z"
        />
        <path
          fill={fill}
          d="M2.48,1.56a.06.06,0,0,1-.06-.06.06.06,0,0,1,.06-.06.47.47,0,0,0,.33-.14A.45.45,0,0,0,3,1,.06.06,0,0,1,3,.91.06.06,0,0,1,3.07,1a.59.59,0,0,1-.17.42A.61.61,0,0,1,2.48,1.56Z"
        />
        <path
          fill={fill}
          d="M1.55,2a.05.05,0,0,1,0,0,0,0,0,0,1,0-.08l.28-.29a.06.06,0,0,1,.09.09l-.29.28A.05.05,0,0,1,1.55,2Z"
        />
        <path
          fill={fill}
          d="M.34,3.45A.17.17,0,0,1,.22,3.4L.05,3.23A.16.16,0,0,1,.05,3L1.27,1.77a.18.18,0,0,1,.24,0l.17.17a.18.18,0,0,1,0,.24L.46,3.4A.17.17,0,0,1,.34,3.45Zm1-1.61a.05.05,0,0,0,0,0L.14,3.08a0,0,0,0,0,0,.07l.16.16s.06,0,.07,0L1.59,2.1a0,0,0,0,0,0-.07l-.17-.17Z"
        />
      </g>
    </g>
  </svg>
);

export default SVG;
